<template lang="pug">
  #section3
    #s3s1.group
      .background.block
        .title.text-center
          h2.py-0.uppercase.light ¿Y el COVID-19? 
        .capside
          img(src="/assets/img/chapter1/transmision.png")
      #s3s1t1.block
        .fake-header
        .slide
          p La enfermedad COVID-19 es causada por el virus SARS-CoV-2 (síndrome respiratorio agudo grave asociado al coronavirus 2), que ha sido clasificado en el género de los β-coronavirus.
        .fake-footer

      #s3s1t2.block
        .fake-header
        .slide
          p El 11 de febrero del 2020 se le dio este nombre al virus ya que está relacionado genéticamente con el virus SARS-CoV. El mismo que en 2003 infectó a 8,098 personas y mató a 774. El genoma de este nuevo virus se parece mucho (90.55%) a otra cepa de coronavirus encontrado en murciélagos herradura. Por eso se cree que pudo haber tenido origen en este tipo de murciélagos. También se ha encontrado que en el pangolín malaya residen coronavirus muy similares (en un 91.2%) a SARS-CoV-2.El virus pudo haber evolucionado lentamente hasta volverse capaz de infectar humanos.
        .fake-footer

      #s3s1t3.block
        .fake-header
        .slide
          p El SARS-CoV-2 es ahora capaz de infectar humanos ya que los picos de proteínas que lo rodean han mutado hasta tener la forma correcta que embona con receptores celulares humanos, haciendo que el virus pueda insertar su material genético en nuestras células. 
        .fake-footer

      #s3s1t4.block
        .fake-header
        .slide
          p Es interesante pensar que SARS es una especie, como lo es la especie humana. Entonces los dos tipos de virus, SARS-CoV-2 (el que nos amenaza este año)  y SARS-CoV (el del 2003), son equivalentes a dos humanos de la misma especie. Como Juan Camaney y Belinda.  
        .fake-footer
</template>

<script>
export default {
  name: "Section3"
};
</script>
<style lang="scss" scoped>
#section3 {
  margin-top: 80vh;
  min-height: 500vh;
  #s3s1 {
    height: 900vh;
    .block {
      @include blockin(100%, 100%, 0, 0%);
      .title {
        position: sticky;
        top: 15%;
        left: 5%;
        width: 90%;
        min-width: 250px;
        max-width: 500px;
        margin-bottom: 64%;
      }
      .capside {
        position: sticky;
        top: 65%;
        img {
          width: 65%;
          max-width: 333px;
          min-width: 100px;
          margin: 0px -10px;
        }
      }
      .slide {
        //height: 50%;
        h2,
        p {
          margin-top: 5rem;
          @include blockinP(90%, 22%, 5%);
          min-width: 250px;
          max-width: 500px;
          text-align: center;
        }
      }
    }
    #s3s1t1 {
      @include blockin(100%, 25%, 0%, 0%);
      .fake-header {
        @include fakinH(2vh, 0%);
      }
      .fake-footer {
        @include fakinF(3vh, 0%);
      }
    }
    #s3s1t2 {
      @include blockin(100%, 25%, 25%, 0%);
      .fake-header {
        @include fakinH(2vh, -3%);
      }
      .fake-footer {
        @include fakinF(3vh, 3%);
      }
    }
    #s3s1t3 {
      @include blockin(100%, 25%, 50%, 0%);
      .fake-header {
        @include fakinH(2vh, -3%);
      }
      .fake-footer {
        @include fakinF(3vh, 3%);
      }
    }
    #s3s1t4 {
      @include blockin(100%, 25%, 75%, 0%);
      .fake-header {
        @include fakinH(2vh, -3%);
      }
      .fake-footer {
        @include fakinF(3vh, 3%);
      }
    }
    svg {
      position: sticky;
      margin-left: -30%;
      top: 69%;
      z-index: -1;
    }
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #section3 {
    #s3s1 {
      .block {
        .title {
          left: 5%;
          width: 90%;
          margin-bottom: 64%;
          margin-left: auto;
          margin-right: auto;
        }
        .capside {
          top: 50%;
          width: 60%;
          img {
            width: 100%;
            max-width: 700px;
            min-width: 100px;
            margin: 0px -10px;
          }
        }
        .slide {
          h2,
          p {
            @include blockinP(90%, 25%, 5%);
            max-width: 700px;
          }
        }
      }
    }
  }
}

@media (min-width: 992px) and (max-width: 1399px) {
  #section3 {
    #s3s1 {
      .block {
        .title {
          position: sticky;
          top: 15%;
          left: 55%;
          width: 40%;
          min-width: 250px;
          max-width: 500px;
          margin-bottom: 64%;
          margin-right: auto;
          margin-left: auto;
        }
        .capside {
          position: sticky;
          top: 5%;
          img {
            width: 65%;
            max-width: 650px;
            min-width: 100px;
            margin: 0px -10px;
          }
        }
        .slide {
          h2,
          p {
            margin-top: 5rem;
            @include blockinP(45%, 22%, 50%);
            min-width: 250px;
            max-width: 700px;
            text-align: center;
            margin-right: auto;
            margin-left: auto;
          }
        }
      }
      #s3s1t4 {
        .fake-footer {
          @include fakinF(3vh, 9%);
        }
      }
    }
  }
}

@media (min-width: 1400px) {
  #section3 {
    #s3s1 {
      .block {
        .title {
          position: sticky;
          top: 15%;
          left: 55%;
          width: 40%;
          min-width: 250px;
          max-width: 500px;
          margin-bottom: 64%;
          margin-right: auto;
          margin-left: auto;
        }
        .capside {
          position: sticky;
          top: 5%;
          img {
            width: 65%;
            max-width: 750px;
            min-width: 100px;
            margin: 0px -10px;
          }
        }
        .slide {
          h2,
          p {
            margin-top: 5rem;
            @include blockinP(45%, 22%, 50%);
            min-width: 250px;
            max-width: 700px;
            text-align: center;
            margin-right: auto;
            margin-left: auto;
          }
        }
      }
      #s3s1t4 {
        .fake-footer {
          @include fakinF(3vh, 9%);
        }
      }
    }
  }
}
</style>
